export enum Tag {
  Rush = 'Rush',
  Turtle = 'Turtle',
  Harassment = 'Harassment',
  Micro = 'Micro',
  Macro = 'Macro',
  AllIn = 'All-in',
  Defensive = 'Defensive',
  CQC = 'CQC',
  Light = 'Light',
  Heavy = 'Heavy',
  Artillery = 'Artillery',
  Air = 'Air',
  Meme = 'Meme',
  Spam = 'Spam',
  Ranked = 'Ranked',
  Team = 'Team',
  Para = 'Para',
  Meta = 'Meta',
  AntiMeta = 'Anti-Meta',
  OneVsOne = '1v1',
  TwoVsTwo = '2v2',
  ThreeVsThree = '3v3',
  FourVsFour = '4v4',
  TenVsTen = '10v10',
  Cheese = 'Cheese',
  Early = 'Early',
  Mid = 'Mid',
  Late = 'Late',
  SlowGrind = "Slow Grind",
  Helo = "Helo",
  PlayForKD = "Play for K/D",
}

const tags = Object.values(Tag);
export { tags };

/**
 * Check if a tag is valid (exists in the allowed tag list)
 */
export function isValidTag(tag: string): boolean {
  return tags.includes(tag as Tag);
}

/**
 * Validate a comma-separated tag string
 * @param tagsString - Comma-separated string of tags (e.g., "Rush,Turtle,Micro")
 * @returns Validation result with valid flag and optional error message
 */
export function validateTags(tagsString: string | null | undefined): { valid: boolean; error?: string } {
  // Empty or null tags are valid (tags are optional)
  if (!tagsString || tagsString.trim() === '') {
    return { valid: true };
  }

  // Split by comma and trim each tag
  const tagArray = tagsString.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0);

  // Check tag count (0-5 tags allowed)
  if (tagArray.length > 5) {
    return { valid: false, error: 'Maximum 5 tags allowed' };
  }

  // Validate each tag against allowed list
  for (const tag of tagArray) {
    if (!isValidTag(tag)) {
      return { valid: false, error: `Invalid tag: "${tag}". Only predefined tags are allowed.` };
    }
  }

  return { valid: true };
}







